import React, {Fragment, useEffect, useRef, useState} from "react";
import {isStockable} from "../stockable";
import {applyLang, getCurrencyFormater} from "../../../i18n";
import {ASSET_URL} from "../../../config";
import {Trans} from "@lingui/react/macro";
import {getProductPrice} from "./devise-choice";


export default function ProductsCardModal({getRef,context,campagneData,formRef,defaultSelectedProducts,initialFreeAmount,divide,selectedDevise,rate,deviseType,principalDevise,forceMonth,nbMonth,onSubmit})
{
    const firstSelection=useRef(true)

    const [showMoreProducts,setShowMoreProducts]=useState( defaultSelectedProducts.length>0)
    const [selectedProducts,setSelectedProducts]=useState(defaultSelectedProducts || [])

    const products_stocks=campagneData?.stats?.total?.stocks || []

    useEffect(() => {
        //console.log(defaultSelectedProducts)
        setShowMoreProducts(defaultSelectedProducts.length>0)

        if(defaultSelectedProducts.length>0){
            setSelectedProducts(defaultSelectedProducts)
        }
    }, [defaultSelectedProducts]);

    //RECALCUL STOCK
    useEffect(()=>{
        if(isStockable(campagneData))
        {
            for(let s of products_stocks){
                let quantity=selectedProducts.filter(i=>i===s.id) ?.length|| 0
                let stock=s.stock
                if(stock>-1)
                {
                    if(quantity>stock){
                        setSelectedProducts(_s=>{
                            _s=_s.filter(i=>i!==s.id)
                            for(let i=0;i<stock;i++){
                                _s.push(s.id)
                            }
                            return _s;
                        })
                    }
                }
            }
        }
    },[JSON.stringify(products_stocks)])

    useEffect(()=>{
       if(getRef){
           getRef({selectedProducts})
       }
       if(firstSelection.current && selectedProducts.length===0 && initialFreeAmount>0){
           formRef?.current?.setFieldValue("montant",initialFreeAmount)
       }else{
           calculMontantBySelectedProducts(selectedProducts)
       }
       firstSelection.current=false
    },[selectedProducts])

    // Recalcule le montant quand la devise (ou le taux) change, UNIQUEMENT si des produits
    // sont sélectionnés (leurs prix sont exprimés dans la devise choisie). Sinon on ne touche
    // PAS au champ montant : un montant libre tapé par le donateur est conservé tel quel
    // (sa devise est simplement réinterprétée ; la bannière indique le débit réel).
    useEffect(()=>{
        if(selectedProducts.length>0){
            calculMontantBySelectedProducts(selectedProducts)
        }
    },[selectedDevise,rate])

    const isMobile=context.isMobile
    //const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })
    const baseFormater=getCurrencyFormater(context)
    // Formate dans la devise sélectionnée (override sinon devise principale).
    const formater=(amount,mfd=0)=>baseFormater(amount,mfd,selectedDevise)

    // Prix d'un produit dans la devise sélectionnée (règle partagée avec modal-don).
    const priceOf=(product)=>getProductPrice(product,selectedDevise,principalDevise,rate,deviseType)

    const calculMontantBySelectedProducts=(_selectedProducts = [])=>{
        let _montant=0
        for(let sp of _selectedProducts)
        {
            const _p=campagneData.products.find(i=>i.id===sp)
            if(_p){
                _montant+=priceOf(_p)
            }
        }

        if(_montant<1){
            _montant=1
            if(forceMonth || isStockable(campagneData)){
                _montant=0
            }
        }

        formRef?.current.setFieldValue("montant",_montant)

        const divideAmount=campagneData?.config?.forceDivideGTEAmount || 0
        const divideNb=campagneData?.config?.forceDivideNB || 12
        if(divideAmount && divideNb && _montant>=divideAmount){
            formRef?.current.setFieldValue("divide",divideNb)
        }
    }

    const addSelectedProduct=(productId)=>{
        const p=campagneData.products.find(i=>i.id===productId)
        if(p && p.divide){
            // montant exprimé dans la devise sélectionnée (onSubmit reconvertit selon la devise).
            onSubmit({montant:priceOf(p),divide:p.divide,selectedProductId:p.id})
            return false
        }

        let _products=[...selectedProducts,productId]
        setSelectedProducts(_products)
        calculMontantBySelectedProducts(_products)
    }
    const removeSelectedProduct=(productId)=>{
        let _sproducts=[...selectedProducts]

        for(let i=0;i<_sproducts.length;i++){
            if(_sproducts[i] === productId){
                _sproducts.splice(i,1)
                break
            }
        }
        setSelectedProducts(_sproducts)
        calculMontantBySelectedProducts(_sproducts)
    }

    let products=campagneData.products || []

    products=products.sort((a,b)=>{
        if(a.position === b.position){
            return 0
        }
        return a.position>b.position?1:-1
    })

    if(!showMoreProducts && !campagneData?.config?.noModal){
        products=products.slice(0,2)
    }

    if(products.length === 0){
        return null
    }

    const stocks=campagneData?.stats?.total?.stocks || []

    return(
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center", marginBottom: 30}}>
            <div style={{
                width:"100%",
                display: "flex",
                flexDirection:isMobile?"column":"row",
                gap: 10,
                justifyContent: "space-between",
                flexWrap:"wrap"
            }}>

                {products.filter(i=>i.montant>0).map(p => {
                    p=applyLang(p,context.lang)
                    const price=priceOf(p)
                    const quantity=selectedProducts.filter(i=>i===p.id).length

                    let allowAdd=true
                    let stock=null
                    let outOfStock=false
                    if(isStockable(campagneData) && stocks.find(i=>i.id===p.id && i.stock>-1)){
                        stock=stocks.find(i=>i.id===p.id)?.stock
                    }

                    if(stock!==null && quantity+1>stock){
                        allowAdd=false
                    }

                    if(stock===0){// OUT OF STOCK
                        outOfStock=true
                    }



                    return (
                        <div key={p.id} onClick={(quantity === 0 && !outOfStock) ? () => addSelectedProduct(p.id) : null}
                             className={quantity === 0 ? "modal-submit-product-card" : undefined} style={{
                            display: "flex",
                            columnGap:10,
                            width: isMobile?"100%":"49%",
                            padding: 15,
                            border: "1px solid #DEDEDE",
                            userSelect:outOfStock?"none !important":"auto",
                            cursor:outOfStock?"not-allowed":"pointer",
                            backgroundColor:outOfStock?"#DEDEDE":"inherit"
                        }}>
                            {p.image && (
                                <div>
                                    <img src={ASSET_URL + p.image} style={{
                                        borderRadius: "100%",
                                        width: 50,
                                        height: 50,
                                        objectFit: "cover"
                                    }}/>
                                </div>
                            )}

                            <div style={{width:"100%"}}>
                                <div>
                                    <span className={"modal-submit-product-card-title"}>{p.name}</span>
                                </div>

                                {p.description && (
                                    <div>
                                        <span className={"modal-submit-product-card-description"}>{p.description}</span>
                                    </div>
                                )}


                                <div style={{
                                    marginTop: 5,
                                    display: "flex",
                                    justifyContent:"space-between"
                                }}>


                                    {!divide && !forceMonth &&(
                                        <Fragment>
                                            {quantity<=1 && !p.divide && (
                                                <span style={{fontWeight: 300,fontSize:"0.9rem"}}>{formater(price)}</span>
                                            )}

                                            {quantity<=1 && p.divide && (
                                                <span style={{fontWeight: 300,fontSize:"0.9rem"}}>{formater(Math.ceil(price / p.divide))} x {p.divide} <Trans>mois</Trans></span>
                                            )}

                                            {quantity>1 && (
                                                <span style={{fontWeight: 300}}>{formater(price)} x{quantity} <span style={{fontWeight: 500}}>{formater(price*quantity)}</span> </span>
                                            )}
                                        </Fragment>
                                    )}

                                    {!!divide && !forceMonth &&(
                                        <Fragment>
                                            {quantity<=1 && (
                                                <span style={{fontWeight: 300,fontSize:"0.9rem"}}>{formater(Math.ceil(price/divide))} <Trans>/mois</Trans></span>
                                            )}

                                            {quantity>1 && (
                                                <span style={{fontWeight: 300}}>{formater(price/divide)} x{quantity} <span style={{fontWeight: 500}}>{formater(Math.ceil((price*quantity)/divide))} <Trans>/mois</Trans></span> </span>
                                            )}
                                        </Fragment>
                                    )}

                                    {forceMonth &&(
                                        <Fragment>
                                            {quantity<=1 && (
                                                <span style={{fontWeight: 300,fontSize:"0.9rem"}}>{formater(price)} <Trans>/mois</Trans></span>
                                            )}

                                            {quantity>1 && (
                                                <span style={{fontWeight: 300}}>{formater(price)} x{quantity} <span style={{fontWeight: 500}}>{formater(price*quantity)} <Trans>/mois</Trans></span> </span>
                                            )}
                                        </Fragment>
                                    )}


                                    {quantity>0 && (
                                        <div style={{
                                            width: "6rem",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems:"center"
                                        }}>
                                            <div className={"modal-submit-product-card-quantity-button"} onClick={() => removeSelectedProduct(p.id)} style={{
                                                width: "2rem",
                                                height: "2rem",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                borderRadius: "100%",
                                                backgroundColor: "#EDEDED"
                                            }}>-</div>

                                            <span style={{fontSize:"1rem"}}>{quantity}</span>

                                            <div className={"modal-submit-product-card-quantity-button"} onClick={() => addSelectedProduct(p.id)} style={{
                                                width: "2rem",
                                                height: "2rem",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                borderRadius: "100%",
                                                backgroundColor: allowAdd?"#EDEDED":"#999",
                                                pointerEvents:allowAdd?"auto":"none",
                                            }}>+</div>

                                        </div>
                                    )}

                                    {outOfStock && (
                                        <div style={{
                                            width: "6rem",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems:"center"
                                        }}>
                                            <span><Trans>Épuisé</Trans></span>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </div>
                    )
                })}

                {products.length%2===1 &&(
                    <div style={{display: "flex",flexBasis:"49%"}}/>
                )}
            </div>

            {!showMoreProducts && !campagneData?.config?.noModal && products.length<campagneData.products.length &&(
                <span
                    onClick={()=>setShowMoreProducts(true)}
                    className="modal-submit-product-card-showmore"
                    style={{marginTop:"1rem",cursor:"pointer",fontWeight:900}}
                ><Trans>Voir Plus</Trans></span>
            )}
        </div>
    )
}
